<template>
  <a-modal
    v-model="localVisible"
    :width="multiple ? 1000 : 720"
    :title="localTitle"
    :destroy-on-close="true"
    :get-container="getContainer"
    class="select-modal vxe-table--ignore-clear"
    :class="{ 'single-choose-modal': !multiple }"
  >
    <div class="modal-top">
      <!-- 其它筛选组件 -->
      <template v-for="filter in filterConfig">
        <component
          :is="filter.name"
          :key="filter.key"
          :default-value="filter.defaultValue"
          :options="filter.options"
          :disabled="filter.disabled"
          :styleObj="filter.style"
          :placeholder="filter.placeholder"
          :value="filterParams[filter.key]"
          @change="onFilterChange(filter.key, $event)"
        />
      </template>
      <!-- 外部通过插槽传入的搜索条件 -->
      <slot ></slot>
      <!-- 关键字搜索框 -->
      <a-input-search
        v-model="filterParams.searchContent"
        allow-clear
        class="search-input-normal"
        :placeholder="`${title}编码/名称`"
        style="width: 240px"
        @search="handleSearch"
      >
        <a-button class="search-icon" slot="enterButton">
          <sass-icon type="hi-112112321234" style="font-size: 16px" />
        </a-button>
      </a-input-search>
      <a-button class="btn-reset-modal" @click="handleReset">重置</a-button>
    </div>
    <div class="modal-body">
      <vxe-grid
        ref="modalTable"
        class="modal-table page-table"
        :columns="localColumns"
        :data="list"
        :checkbox-config="checkboxConfig"
        show-overflow="tooltip"
        show-header-overflow="tooltip"
        :highlight-current-row="!multiple"
        :row-id="localAttrKeys.value"
        :height="multiple ? 430 : 409"
        size="small"
        :loading = "loading"
        :style="{ width: multiple ? '707px' : '692px' }"
        @current-change="handleCurrentChange"
        @checkbox-change="handleCheckboxChange"
        @checkbox-all="handleCheckboxAll"
      >
        <template #empty>
          <div class="empty-icon">
            <sass-icon type="hi-nodata" style="font-size: 50px" />
          </div>
        </template>
        <template #top v-if="multiple">
          <h3 class="multiple-select-wait">待选{{ title }}({{ total }})</h3>
        </template>
        <template #pager>
          <div :class="['pager', { 'between-pager': !multiple }]">
            <span v-if="!multiple" class="counter">
              共
              <a href="javascript:void(0)">{{ total }}</a>
              条数据
            </span>
            <a-pagination
              v-model="filterParams.pageNo"
              class="modal-page"
              :pageSize.sync="filterParams.pageSize"
              :total="total"
              :pageSizeOptions="pageSizeOptions"
              show-size-changer
              show-quick-jumper
              @change="onPageChange"
              @showSizeChange="onSizeChange"
            />
          </div>
        </template>
      </vxe-grid>
      <selected-list
        v-if="multiple"
        :title="title"
        :list.sync="localSelected"
        :attr-keys="localAttrKeys"
        @del-item="delItem"
        @clear-all="clearAll"
      />
    </div>
    <template #footer>
      <footer v-if="multiple" class="footer-select-modal">
        <a-button type="primary" @click="handleConfirm">确定</a-button>
        <a-button @click="handleCancel">取消</a-button>
      </footer>
    </template>
  </a-modal>
</template>
<script>
import { uniqBy } from 'lodash'
import selectedList from './selectedList'
import generalSelect from './generalSelect'
import dateSelect from './dateSelect'
import periodDateSelect from './periodDateSelect'
export default {
  name: 'SelectModal',
  components: {
    selectedList,
    generalSelect,
    dateSelect,
    periodDateSelect
  },
  props: {
    // 选中数据
    selected: {
      type: [Array, Object, String, Number],
      default() {
        return []
      }
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 选项属性和筛选条件的key
    attrKeys: {
      type: Object,
      default() {
        return {}
      }
    },
    // 标题关键字：用来拼接标题和搜索框的placehoder
    title: {
      type: String,
      default: ''
    },
    // 是否显示弹框
    visible: {
      type: Boolean,
      default: false
    },
    // 默认列表数据
    list: {
      type: [Array, Object, String],
      default() {
        return []
      }
    },
    // 额外的动态参数
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    // 弹出框表格配置
    columns: {
      type: Array,
      required: true
    },
    // 其它筛选项配置
    filterConfig: {
      type: Array,
      default() {
        return []
      }
    },
    // 弹框挂载的元素实例
    containerSelector: {
      type: String,
      default: 'body'
    },
    // 弹框是否可拖动
    draggable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    // 指定每页可以显示多少条
    pageSizeOptions: {
      type: Array,
      default() {
        return ['10', '20', '50', '100', '200', '500']
      }
    }
  },
  data() {
    return {
      localSelected: this.selected,
      filterParams: {
        searchContent: '',
        pageNo: 1,
        pageSize: 20
      },
      checkboxConfig: {
        reserve: true,
        highlight: true,
        // 如果有disabled则该行不能选
        checkMethod({ row }) {
          return !row.disabled
        }
      }
    }
  },
  computed: {
    // 属性key的组合
    localAttrKeys() {
      const { attrKeys } = this
      return {
        searchContent: 'searchContent',
        pageNo: 'pageNo',
        pageSize: 'pageSize',
        total: 'total',
        value: 'id',
        label: 'name',
        ...attrKeys
      }
    },
    // 弹框是否可显示
    localVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    // 标题拼接
    localTitle() {
      return `选择${this.title}`
    },
    // 表头拼接
    localColumns() {
      const { columns, multiple } = this
      const perfix = multiple
        ? [
          {
            type: 'checkbox',
            resizable: false,
            align: 'center',
            width: 50
          }
        ]
        : []
      const suffix = !multiple
        ? [
          {
            title: '操作',
            slots: {
              // eslint-disable-next-line no-unused-vars
              default: ({ row }, h) => {
                return row.disabled
                  ? [h('span', { class: ['disabled'] }, '选择')]
                  : [h('a', {}, '选择')]
              }
            }
          }
        ]
        : []
      return [...perfix, ...columns, ...suffix]
    }
  },
  watch: {
    localVisible(val) {
      if (val) {
        // 当打开弹框时
        this.init()
      }
    },
    // 外部参数变化，调用初始化函数，重新获取数据
    params: {
      handler() {
        this.filterParams.pageNo = 1
        this.queryList()
      },
      deep: true
    },
    list: {
      // 如果列表中有值，且已选中不为空，则左侧勾选操作。
      handler(arr) {
        if (arr && arr.length > 0 && this.selected.length > 0) {
          const selected = [...this.selected]
          this.setRowsChecked(selected)
        }
      },
      deep: true
    }
  },
  methods: {
    isNull(v) {
      return (
        v === undefined ||
        v == null ||
        v === '' ||
        v === -1 ||
        (typeof v === 'number' && isNaN(v))
      )
    },
    // 初始化方法
    init() {
      const {
        setContainerCSS,
        resetFilterParams,
        setRowsChecked,
        selected
      } = this
      setContainerCSS()
      resetFilterParams()
      this.queryList()
      if (this.multiple) {
        // 初始化上一级组件带来的选中条目，拷贝以避免数据相互影响
        this.localSelected = [...selected]
        setRowsChecked()
      }
    },
    // 查询列表
    queryList() {
      const {
        // eslint-disable-next-line no-unused-vars
        localAttrKeys: { total, searchContent, pageSize, pageNo }
      } = this
      const filterParams = { ...this.filterParams, ...this.params }
      // 移除 pageNo，pageSize, total, searchContent
      const {
        pageNo: page,
        pageSize: size,
        searchContent: keyword
      } = filterParams
      delete filterParams.pageNo
      delete filterParams.pageSize
      delete filterParams.searchContent
      delete filterParams.total
      // 设置 分页字段
      filterParams[searchContent] = keyword
      filterParams[pageNo] = page
      filterParams[pageSize] = size
      // 过滤掉空白的值（’‘，null,undefined,-1, NaN）,不传递给后端
      for (const key in filterParams) {
        if (this.isNull(filterParams[key])) {
          delete filterParams[key]
        }
      }
      this.$emit('queryList', filterParams) // 查询获取成功，将数组传递出去
    },
    // 设置表格默认选中条目,初始化和分页跳转时调用
    setRowsChecked(records) {
      const { localSelected, multiple } = this
      if (!multiple) return
      records = records || localSelected
      const modalTable = this.$refs.modalTable
      if (modalTable) {
        modalTable.setAllCheckboxRow(false)
        modalTable.setCheckboxRow(records, true)
      }
    },
    // 單選時當前行改變事件
    handleCurrentChange({ row }) {
      const { multiple, handleCancel } = this
      // 禁用的不能被选择
      if (multiple || row.disabled) return
      this.$emit('update:selected', row)
      handleCancel()
    },
    // checkbox勾选事件返回函数
    handleCheckboxChange({ checked, row }) {
      const {
        localSelected,
        localAttrKeys: { value }
      } = this
      if (checked) {
        this.localSelected = [...localSelected, row]
      } else {
        const idx = localSelected.findIndex(
          (item) => item[value] === row[value]
        )
        this.localSelected.splice(idx, 1)
      }
    },
    // checkbox全选事件返回函数
    handleCheckboxAll({ records, checked }) {
      const that = this
      const {
        localSelected,
        localAttrKeys: { value }
      } = this
      if (checked) {
        that.localSelected = uniqBy([...localSelected, ...records], value)
      } else {
        const recordIds = this.list.map((i) => i[value])
        recordIds.forEach((item) => {
          const idx = localSelected.findIndex((j) => j[value] === item)
          that.localSelected.splice(idx, 1)
        })
      }
    },
    // 确定按钮点击事件返回函数
    handleConfirm() {
      const { multiple, localSelected, handleCancel } = this
      if (!multiple) return
      this.$emit('update:selected', localSelected)
      handleCancel()
    },
    // 取消按钮点击事件返回函数
    handleCancel() {
      // 清空当前已选数据
      this.localSelected = []
      this.localVisible = false
    },
    // 从列表中删除某个条目后的返回函数
    delItem(items) {
      const {
        localAttrKeys: { value },
        setRowsChecked
      } = this
      const modalTable = this.$refs.modalTable
      const itemIds = items.map((item) => item[value])
      let records = modalTable.getCheckboxRecords()
      records = records.filter((record) => !itemIds.includes(record[value]))
      setRowsChecked(records)
    },
    // 清除所有选中数据后的返回函数
    clearAll() {
      const modalTable = this.$refs.modalTable
      if (modalTable) {
        modalTable.setAllCheckboxRow(false)
      }
    },
    // 搜索事件
    handleSearch(value) {
      this.filterParams.pageNo = 1
      this.filterParams.searchContent = value
      this.queryList()
    },
    // 重置事件
    handleReset() {
      this.$emit('reset')
      this.resetFilterParams()
      this.queryList()
    },
    // 当前页改变事件返回函数
    onPageChange(page) {
      this.filterParams.pageNo = page
      this.queryList()
    },
    // 当前显示条目数改变事件返回数
    onSizeChange(current, size) {
      this.filterParams.pageSize = size
      this.filterParams.pageNo = current
      this.queryList()
    },
    // 重置筛选条件
    resetFilterParams() {
      const {
        localAttrKeys: { ...otherKeys },
        filterParams
      } = this
      const keys = Object.keys(otherKeys)
      keys.forEach((key) => {
        if (typeof otherKeys[key] === 'string') {
          filterParams[otherKeys[key]] = ''
        }
      })
      this.filterConfig.forEach((e) => {
        if (e.defaultValue || e.defaultValue === 0) {
          filterParams[e.key] = e.defaultValue
        }
      })
      filterParams.searchContent = ''
      filterParams.pageNo = 1
      filterParams.pageSize = 20
    },
    // 传入的筛选器改变事件
    onFilterChange(key, e) {
      this.$set(this.filterParams, key, e)
      this.filterParams.pageNo = 1
      this.filterParams.pageSize = 20
      this.queryList()
    },
    // 弹框挂载的元素
    getContainer() {
      const { containerSelector } = this
      return typeof containerSelector === 'function'
        ? containerSelector()
        : document.querySelector(containerSelector)
    },
    // 设置挂载节点的样式以适应弹框，需要配合样式中的 .ant-modal-wrap, .ant-modal-mask 类的样式才生效
    setContainerCSS() {
      const { getContainer } = this
      const container = getContainer()
      container.setAttribute('style', 'position: relative;')
    }
  }
}
</script>
<style lang="less" scoped>
.select-modal::v-deep {
  .ant-modal-wrap,
  .ant-modal-mask {
    // 需要配合方法中的 setContainerCSS 才生效
    position: absolute;
  }
  .ant-modal-body {
    padding: 0;
  }
  .vxe-grid--pager-wrapper {
    margin-top: 12px;
    padding: 8px 0;
    display: flex;
    justify-content: flex-end;
  }
}
.btn-reset-modal {
  padding: 0 11px;
}
.modal-top {
  align-items: center;
  padding: 12px 16px 7px;
  & > * {
    margin-right: 8px;
    margin-bottom: 5px;
  }
}
.modal-body {
  padding: 0 16px;
  display: flex;
}
.modal-table {
  flex: 1;
}
.pager {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &.between-pager {
    justify-content: space-between;
  }
}
.multiple-select-wait {
  line-height: 22px;
  padding-bottom: 4px;
}
</style>

<style lang="less">
.disabled {
  color: rgba(0, 0, 0, 0.25);
}
.select-modal {
  .modal-page {
    .ant-pagination {
      display: inline-block;
      height: 24px;
      line-height: 1;
    }
    .go-btn {
      margin-left: 5px;
      position: relative;
      top: -7px;
    }
    input {
      margin: 0 5px;
    }
    .ant-pagination-item,
    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      height: 24px;
      line-height: 22px;
      min-width: 24px;
      font-size: 12px;
    }
    .ant-pagination-prev,
    .ant-pagination-item {
      margin-right: 5px;
    }
    .ant-pagination-options {
      margin-left: 5px;
    }
    .ant-pagination-options-quick-jumper {
      line-height: 24px;
      height: 24px;
      margin-left: 10px;
      input {
        height: 24px;
        line-height: 22px;
      }
    }
    .ant-pagination-options-size-changer.ant-select {
      margin-right: 0;
    }
    .ant-pagination-options-size-changer.ant-select
      .ant-select-selection--single,
    .ant-pagination-options-size-changer.ant-select
      .ant-select-selection--single
      .ant-select-selection__rendered {
      height: 24px;
      line-height: 22px;
    }
  }
  .vxe-table--render-default.size--small .vxe-body--column.col--ellipsis,
  .vxe-table--render-default.size--small .vxe-footer--column.col--ellipsis,
  .vxe-table--render-default.size--small .vxe-header--column.col--ellipsis,
  .vxe-table--render-default.vxe-editable.size--small .vxe-body--column {
    height: 32px;
    line-height: 32px;
  }
  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #333333;
  }
  .ant-pagination-item a {
    padding: 0 1px;
  }
  .footer-select-modal {
    .ant-btn {
      padding: 0 17px;
      height: 32px;
      line-height: 32px;
    }
  }
  .ant-modal-footer {
    padding: 11px 16px;
  }
  &.single-choose-modal {
    .ant-modal-footer {
      display: none;
    }
    .vxe-grid--pager-wrapper {
      margin-top: 0;
      padding: 16px 0;
    }
  }
  .ant-pagination-options:last-of-type
    .ant-pagination-options-size-changer.ant-select {
    margin-right: 0;
  }
}
.vxe-loading .vxe-loading--spinner:after, .vxe-loading .vxe-loading--spinner:before{
  background-color: #00a497;
}
</style>
